import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from './constants';

@Injectable()
export class GroupService {
  private apiUrl = this.appConfig.API_URL_WEB;
  private apiUrlSync = this.appConfig.API_URL_POServicios;

  private headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

  constructor(public http: HttpClient, private appConfig: AppConfig) {

  }

  /*
  createHeader(token) {
    this.headers = {headers: new HttpHeaders({ 'Content-Type': 'application/json' })};//, 'token': token
  }
  */

  createHeader(tmpToken : any ) {

    let token = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.headers = {headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    })};// , 'token': token
  }



  newCompany(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Empresas', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  getCompanies(token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'Empresas', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getCompaniesActive(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'user/'+userId+'/companies-active', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  getCompany(id, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'Empresas/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  updateCompany(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'Empresas/'+id, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getUsersAuth(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlSync+'AdministracionDeAprobadores', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  assignUserAuth(params, userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'AdministracionDeAprobadores?idUsuarioSAP='+params.idUsuarioSAP+'&idUsuarioPortal='+params.idUsuarioPortal, {data: true}, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  reassignUserAuth(params, userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.delete(this.apiUrlSync+'AdministracionDeAprobadores?idUsuarioSAP='+params.idUsuarioSAP+'&idUsuarioPortal='+params.idUsuarioPortal, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }




  statusCompany(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'user/'+userId+'/companies/'+id+'/status', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  newOffice(params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'user/'+userId+'/offices', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  getOffices(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'user/'+userId+'/offices', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  getOffice(id, userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'user/'+userId+'/offices/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  updateOffice(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'user/'+userId+'/offices/'+id, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  statusOffice(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'user/'+userId+'/offices/'+id+'/status', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getApprovers(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'user/'+userId+'/users-approver', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getWorkflows(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'user/'+userId+'/workflows', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  workflowApprover(params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'user/'+userId+'/workflows-approvers', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getAprobationServices(params, token){


  }

}
